import type { RouteRecordRaw } from 'vue-router';
import { useCartRouteGuards } from './composables';

const { createCartGuard } = useCartRouteGuards();
const completedCartGuard = createCartGuard('completed');
const pendingCartGuard = createCartGuard('pending');

export default <RouteRecordRaw[]>[
  // ACTIVE CART
  {
    path: 'animal/outcome/',
    name: 'animal-outcome',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/outcome/:id',
    name: 'animal-outcome-with-id',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/intake-payment/',
    name: 'animal-intake-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/intake-payment/:id',
    name: 'animal-intake-with-id',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'donation/payment/',
    name: 'donation-intake-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'donation/payment/:id/:isAnonymous?',
    name: 'donation-with-id',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/foster-payment/',
    name: 'foster-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/foster-payment/:id',
    name: 'foster-payment-with-id',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/equipment-rental-payment/',
    name: 'equipment-rental-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/equipment-rental-payment/:id',
    name: 'equipment-rental-payment-with-id',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'animal/foster-payment-pending/:id',
    name: 'foster-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },

  // PENDING PAYMENT CART
  {
    path: 'animal/outcome-pending/',
    name: 'animal-outcome-pending-no-id',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'animal/outcome-pending/:id',
    name: 'animal-outcome-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'animal/intake-payment-pending/',
    name: 'animal-intake-payment-pending-no-id',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'animal/intake-payment-pending/:id',
    name: 'animal-intake-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'donation/payment-pending/',
    name: 'donation-payment-pending-no-id',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'donation/payment-pending/:id',
    name: 'donation-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'animal/foster-payment-pending/',
    name: 'foster-payment-pending-no-id',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },

  // COMPLETED CART
  {
    path: 'animal/outcome-completed/',
    name: 'animal-outcome-completed-no-id',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/outcome-completed/:id',
    name: 'animal-outcome-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/intake-payment-completed/',
    name: 'animal-intake-payment-completed-no-id',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/intake-payment-completed/:id',
    name: 'animal-intake-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'donation/payment-completed/',
    name: 'donation-payment-completed-no-id',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'donation/payment-completed/:id',
    name: 'donation-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/foster-payment-completed/',
    name: 'foster-payment-completed-no-id',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/foster-payment-completed/:id',
    name: 'foster-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/equipment-rental-payment-pending/:id',
    name: 'equipment-rental-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  // RETAIL CART
  {
    path: 'retail/payment/:id?',
    name: 'retail-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'retail/payment-pending/:id',
    name: 'retail-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'retail/payment-completed/:id',
    name: 'retail-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },

  // CITATION CART
  {
    path: 'citation/payment/:id?',
    name: 'citation-payment',
    component: () => import('./views/ShoppingCartActiveView.view.vue'),
    meta: {
      checkoutStatus: 'active',
      noCancelRequests: true,
    },
  },
  {
    path: 'citation/payment-pending/:id',
    name: 'citation-payment-pending',
    component: () => import('./views/ShoppingCartPendingView.view.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
    beforeEnter: pendingCartGuard,
  },
  {
    path: 'citation/payment-completed/:id',
    name: 'citation-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
  {
    path: 'animal/equipment-rental-payment-completed/:id',
    name: 'equipment-rental-payment-completed',
    component: () => import('./views/ShoppingCartCompletedView.view.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
    beforeEnter: completedCartGuard,
  },
];
